$(document).ready(function () {
    if ($(".basket-standard").length) {
        window.history.replaceState({}, document.title, window.location.origin + window.location.pathname);
    }
});
